module.exports = __webpack_public_path__ + "img/grn_ch_azhag_0.bec8d3e4.png";